module.exports = __webpack_public_path__ + "img/burgos_background_hero.c53c6573.png";